import { useMediaQuery } from "@mui/system";
import { Box } from "@mui/material";
import { settings } from "app";
import permissions from "app/permissions";
import { MobileListRow } from "features/MobileListRow";
import {
  Datagrid,
  FunctionField,
  List,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ShowButton,
  SimpleList,
  TextField,
} from "react-admin";
import { EmptyList } from "server/components";
import SecuredComponent from "server/security/SecuredComponent";
import { ErasmusRegularStudentStatus, MOBILE_BREAKPOINT } from "utils/constants";
import CheckArriveModal from "../Partials/CheckArriveModal";
import CheckFinishedModal from "../Partials/CheckFinishedModal";
import SendForSignatureModal from "../Partials/SendForSignatureModal";
import { erasmusRequests } from "api/erasmusApi";
import { administrationRequests } from "api/administrationApi";

const listFilters = [
  <ReferenceInput
    key="status"
    source="status"
    reference={erasmusRequests.getStatusesSelect()}
    alwaysOn
  >
    <SelectInput
      label="Статус"
      optionText="nameBg"
      optionValue="id"
    />
  </ReferenceInput>,
];

const ListIncomingStudentsRegular = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Списък пристигащи студенти за обучение и BIP"
      sx={settings.style.blockStyle}
      filters={listFilters}
      exporter={false}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Имена",
                    value: (
                      <>
                        {record?.firstName} {record?.lastName}
                      </>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Университет",
                    value: (
                      <ReferenceField
                        source="universityId"
                        reference={administrationRequests.getUniversitiesSelect()}
                        sortable={false}
                      >
                        <TextField
                          source="name"
                          emptyText="-"
                        />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Специалност",
                    value: (
                      <ReferenceField
                        source="specialtyId"
                        reference={administrationRequests.getSpecialitiesSelect()}
                        sortable={false}
                      >
                        <TextField
                          source="name"
                          emptyText="-"
                        />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Статус",
                    value: (
                      <ReferenceField
                        label="Статус"
                        source="status"
                        reference={erasmusRequests.getStatusesSelect()}
                        sortable={false}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
            </div>
          )}
          secondaryText={record => (
            <div style={{ display: "flex", gap: 4 }}>
              <SecuredComponent permission={permissions.canManageErasmusRegularStudents}>
                <SendForSignatureModal />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canManageErasmusRegularStudents}>
                <FunctionField
                  render={record =>
                    record?.status === ErasmusRegularStudentStatus.PrintedLoa && (
                      <CheckArriveModal
                        id={record.id}
                        isBip={record.isBip}
                        academicYearId={record.academicYearId}
                        curriculumId={record.curriculumId}
                      />
                    )
                  }
                />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canManageErasmusRegularStudents}>
                <FunctionField
                  render={record => record?.status === ErasmusRegularStudentStatus.Arrived && <CheckFinishedModal />}
                />
              </SecuredComponent>
            </div>
          )}
          tertiaryText={() => <ShowButton label="" />}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.firstExpandIconDatagrid}
        >
          <TextField
            label="Име"
            source="firstName"
            sortable={false}
          />

          <TextField
            label="Фамилия"
            source="lastName"
            sortable={false}
          />
          <ReferenceField
            label="Университет"
            source="universityId"
            reference={administrationRequests.getUniversitiesSelect()}
            sortable={false}
          >
            <TextField
              source="name"
              emptyText="-"
            />
          </ReferenceField>

          <ReferenceField
            label="Специалност"
            source="specialtyId"
            reference={administrationRequests.getSpecialitiesSelect()}
            sortable={false}
          >
            <TextField
              source="name"
              emptyText="-"
            />
          </ReferenceField>
          <ReferenceField
            label="Статус"
            source="status"
            reference={erasmusRequests.getStatusesSelect()}
            sortable={false}
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <SecuredComponent permission={permissions.canManageErasmusRegularStudents}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 1,
              }}
            >
              <SendForSignatureModal />

              <FunctionField
                render={record =>
                  record?.status === ErasmusRegularStudentStatus.PrintedLoa && (
                    <CheckArriveModal
                      id={record.id}
                      isBip={record.isBip}
                      academicYearId={record.academicYearId}
                      curriculumId={record.curriculumId}
                    />
                  )
                }
              />

              <FunctionField
                render={record => record?.status === ErasmusRegularStudentStatus.Arrived && <CheckFinishedModal />}
              />
            </Box>
          </SecuredComponent>

          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};

export default ListIncomingStudentsRegular;
//action buttons POST
